import React, { forwardRef } from 'react';
import { Input } from "antd";
import classNames from 'classnames';

const AntdCustomInput = forwardRef(({ className = "", ...rest }, ref) => {
  return (
    <Input
      ref={ref}
      className={classNames("ant-input", className)}
      {...rest}
    />
  );
});

export default AntdCustomInput;
